import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ABoutUsItem, ServiceGroupItem, TermAndConditionItem } from '../models';

interface SettingState {
  bannerList: any[];
  loading: boolean;
  error: string | null;
  groupList: ServiceGroupItem[];
  aboutUsData: ABoutUsItem;
  termAndConditionData: TermAndConditionItem
}

const initialState: SettingState = {
  bannerList: [],
  loading: false,
  error: null,
  groupList: [],
  aboutUsData: {
    id: 0,
    companyId: '',
    contentEn: '',
    contentAr: '',
    createAt: '',
    updateAt: ''
  },
  termAndConditionData: {
    id: 0,
    companyId: '',
    contentEn: '',
    contentAr: '',
    createAt: '',
    updateAt: ''
  }
};

const settingSlice = createSlice({
  name: 'setting',
  initialState,
  reducers: {
    fetchBannerListStart: (state, action: PayloadAction<any>) => {
      state.loading = true;
      state.error = null;
    },
    fetchBannerListSuccess: (state, action: PayloadAction<any[]>) => {
      state.loading = false;
      state.bannerList = action.payload;
      state.error = null;
    },
    fetchBannerListFailed: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
    fetchListGroupStart: (state, action: PayloadAction<any>) => {
      state.loading = true;
      state.error = null;
    },
    fetchListGroupSuccess: (state, action: PayloadAction<ServiceGroupItem[]>) => {
      state.loading = false;
      state.groupList = action.payload;
      state.error = null;
    },
    fetchListGroupFailed: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
    fetchAboutUsDataStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchAboutUsDataSuccess: (state, action: PayloadAction<ABoutUsItem>) => {
      state.loading = false;
      state.aboutUsData = action.payload;
      state.error = null;
    },
    fetchAboutUsDataFailed: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
    fetchTermAndConditionDataStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchTermAndConditionDataSuccess: (state, action: PayloadAction<ABoutUsItem>) => {
      state.loading = false;
      state.termAndConditionData = action.payload;
      state.error = null;
    },
    fetchTermAndConditionDataFailed: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const settingActions = settingSlice.actions;
export const settingReducer = settingSlice.reducer;

// Selectors
export const selectBannerList = (state: any) => state.setting.bannerList;
export const selectGroupList = (state: any) => state.setting.groupList;
export const selectAboutUsData = (state: any) => state.setting.aboutUsData;
export const selectTermAndConditionData = (state: any) => state.setting.termAndConditionData;
